import React, { useState, useCallback } from 'react';
import useTimeout from 'react-use/lib/useTimeout.js';
import { trackingService } from 'services/tracking/TrackingService.js';
import { useNavigationFrameContext } from 'contexts/NavigationFrameContext.jsx';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';
import { OrgSelectorAndGLobalProductSwitcherRow, ProductMenu } from './styles.js';
import GlobalProductMenu from '../GlobalProductMenu/index.jsx';
import OrgListSelector from './OrgListSelector.jsx';
import OrgProductList from './OrgProductList.jsx';
import { CLIENT_PRODUCT, SUPERADMIN_PRODUCT } from 'constants/products.js';

const ExpandedProductHeader = ({ ref, organizations, handleProductMenuOpen, ...props }) => {
  const { setIsProductHeaderExpanded } = useNavigationFrameContext();
  const { selectedProduct, orgId, clientId } = useProductDataOutsideRoutes();
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isReady, cancel, resetTimeout] = useTimeout(300);

  const handleWorkspaceSelect = useCallback((workspace) => {
    resetTimeout();
    setSelectedOrg(workspace);
  }, [resetTimeout]);

  const closeMenuOnGlobalProductSwitch = useCallback(() => {
    setIsProductHeaderExpanded(false);
    trackingService.track({
      eventType: 'product-menu:close',
      trigger: 'global-product-switch',
    });
  }, [setIsProductHeaderExpanded]);

  const handleSelectingProduct = useCallback(() => {
    handleProductMenuOpen('selecting-product');
  }, [handleProductMenuOpen]);

  const hasOrganizations = organizations?.length > 0;
  const hasMoreThanOneOrganization = organizations?.length > 1;
  const autoSelectSingleOrg = organizations?.length === 1 && (selectedProduct === CLIENT_PRODUCT || selectedProduct === SUPERADMIN_PRODUCT);
  const currentOrg = autoSelectSingleOrg ? organizations[0] : organizations.find((org) => org.id === orgId);

  return (
    <ProductMenu layout {...props}>
      <OrgSelectorAndGLobalProductSwitcherRow id="org-selector-and-global-product-switcher-row" layout>
        {hasMoreThanOneOrganization && (
          <OrgListSelector organizations={organizations} onSelect={handleWorkspaceSelect} orgId={orgId} />
        )}
        <GlobalProductMenu closeMenu={closeMenuOnGlobalProductSwitch} />
      </OrgSelectorAndGLobalProductSwitcherRow>
      {hasOrganizations && (
        <OrgProductList
          id="org-product-selector"
          selectedOrg={selectedOrg}
          selectedProduct={selectedProduct}
          currentOrg={currentOrg}
          selectingProduct={handleSelectingProduct}
          showSkeleton={!isReady()}
        />
      )}
    </ProductMenu>
  );
};

export default React.forwardRef((props, ref) => <ExpandedProductHeader {...props} ref={ref} />);
